export default __webpack_public_path__ + "static/media/pay2b Logo_pay2b-07.260ec2b4.png";